class CarbonBadge {
    constructor(element) {
        this.url = encodeURIComponent(window.location.href);

        // Local debugging URL.
        //this.url = encodeURIComponent('https://stg-skillsforwales-stage.kinsta.cloud/');

        this.element = element;
        this.amountElement = this.element.querySelector('.co2-value');

        this.messages = this.element.querySelectorAll('.carbon-badge__item');

        this.resultCacheLength = 86400000; // milliseconds; 1 day = 86400000; 1 hour = 3600000
        this.resultCacheName = `wcb_${this.url}`;

        if (window.location.href.indexOf('webcarbon-clearcache') > -1) {
            this.clearCachedResult();
        }

        this.init();
    }

    init() {
        const cachedResult = this.getCachedResult();
        let needsNew = false;

        if (CarbonBadge.isValidCacheResult(cachedResult)) {
            this.result = cachedResult.result;
            this.render();

            if (new Date(cachedResult.expiry).getTime() < Date.now()) {
                needsNew = true;
            }
        } else {
            needsNew = true;
        }

        if (needsNew === true) {
            this.requestNewResult().then((result) => {
                if (CarbonBadge.isValidResult(result)) {
                    this.result = result;
                    this.render();
                    this.setCachedResult(result);
                }
            });
        }
    }

    render() {
        if (this.result.c > 0) {
            this.amountElement.innerHTML = `${this.result.c}g`;
            this.element.classList.add('carbon-badge--has-result');
            this.element.removeAttribute('aria-hidden');

            this.renderMessages(this.result);
        } else {
            this.element.classList.remove('carbon-badge--has-result');
            this.element.setAttribute('aria-hidden', true);
        }
    }

    async requestNewResult() {
        const response = await fetch(`https://api.websitecarbon.com/b?url=${this.url}`);

        if (!response.ok) {
            throw new Error(`Error retrieving new calculated carbon emission value for the ${decodeURIComponent(this.url)}.`);
        }

        return response.json();
    }

    static isValidResult(result) {
        return Object.prototype.hasOwnProperty.call(result, 'c') && Object.prototype.hasOwnProperty.call(result, 'p');
    }

    static isValidCacheResult(result) {
        return (
            Object.prototype.hasOwnProperty.call(result, 'result') &&
            Object.prototype.hasOwnProperty.call(result, 'expiry') &&
            CarbonBadge.isValidResult(result.result)
        );
    }

    getCachedResult() {
        let cachedResult = localStorage.getItem(this.resultCacheName);

        if (cachedResult == null) {
            cachedResult = JSON.stringify({
                error: 'No cached result available.',
            });
        }

        return JSON.parse(cachedResult);
    }

    setCachedResult(result) {
        localStorage.setItem(
            this.resultCacheName,
            JSON.stringify({
                result,
                expiry: Date.now() + this.resultCacheLength,
            })
        );
    }

    clearCachedResult() {
        localStorage.removeItem(this.resultCacheName);
    }

    getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    renderMessages(result) {
        const coffeeCO2 = 62.25 //g CO2 based on 1500kW kettle;
        const evCO2 = 150; // CO2 per single mile
        const phoneCO2 = 2.5 //g CO2 with 5W charger;
        let suffix = 's';

        const pluralize = (count, noun, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`;

        this.messages.forEach(message => {
            const icon = message.getAttribute('data-item');
            const unit = message.getAttribute('data-unit');
            const lang = message.getAttribute('data-lang');
            const value = message.querySelector('.cb-value');
            let calc = 0;
            let res = result.c.toFixed(5);

            if (lang === 'cy') {
                suffix = ''; // au
            }

            switch(icon) {
                case 'coffee':
                    calc = (res / coffeeCO2).toFixed(5);
                    value.innerHTML = `${pluralize(calc, unit, suffix)}`;
                    break;
                case 'ev':
                    calc = (res / evCO2).toFixed(5);
                    value.innerHTML = `${pluralize(calc, unit, suffix)}`;
                    break;
                case 'phone':
                    calc = (res / phoneCO2).toFixed(5);
                    value.innerHTML = `${pluralize(calc, unit, suffix)}`;
                    break;
            }
        });

        this.messages[this.getRandomInt(this.messages.length)].classList.add('active');
    }
}

export default CarbonBadge;
